import React from 'react';
import { withStyles, Typography, Paper, List, ListItem, ListItemText, Divider, IconButton, Slide, Fade } from '@material-ui/core';
import ChevronRight from '@material-ui/icons/ChevronRight';
import LibraryAdd from '@material-ui/icons/LibraryAdd';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import AirlineSeatFlatAngled from '@material-ui/icons/AirlineSeatFlatAngled';
import Assignment from '@material-ui/icons/Assignment';
import { Link } from 'react-router-dom';

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit,
  },
  link: {
    textDecoration: 'none',
  },
  titlebar: {
    display: 'flex',
    alignItems: 'center',
  },
});

class ProfissionalPrincipal extends React.Component {
  render () {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <Link to='/dashboard' className={classes.link}>
          <Slide direction='down' timeout={600} in>
            <Paper elevation={1} className={classes.titlebar}>
              <IconButton color='inherit' aria-label='Close'>
                <ChevronLeft />
              </IconButton>
              <Typography variant='headline'>Profissional Odontológico</Typography>
            </Paper>
          </Slide>
        </Link>
        <Paper className={classes.root} elevation={1}>
          <List>
            <Divider />
            <Link to={'/odontologico/cadastro'} className={classes.link}>
              <Fade timeout={600} in>
                <ListItem button key='0'>
                  <LibraryAdd />
                  <ListItemText
                    primary='Cadastro'
                    secondary='Cadastro, alteração e credenciamento de profissionais odontológicos' />
                  <ChevronRight />
                </ListItem>
              </Fade>
            </Link>
            <Divider />
          </List>
        </Paper>
      </React.Fragment>
    );
  }
}
export default withStyles(styles)(ProfissionalPrincipal);
